import React from "react";

export interface IconArrowDownProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconArrowDown: React.FC<IconArrowDownProps> = ({
  width = 25,
  height = 25,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M22.7346 10.6294L23.9733 11.8681C24.4978 12.3926 24.4978 13.2407 23.9733 13.7596L13.1319 24.6066C12.6074 25.1311 11.7593 25.1311 11.2404 24.6066L0.393371 13.7596C-0.131124 13.2351-0.131124 12.387 0.393371 11.8681L1.63207 10.6294C2.16215 10.0993 3.02701 10.1105 3.54592 10.6517L9.95146 17.3753V1.33914C9.95146 0.597032 10.5485 0 11.2906 0H13.0761C13.8182 0 14.4152 0.597032 14.4152 1.33914V17.3753L20.8208 10.6517C21.3397 10.1049 22.2046 10.0937 22.7346 10.6294Z" />
  </svg>
);
